<template>
  <modal :title="label_name + ' (' + total_count + ' annotations2)'" @close_modal="close" :loading="loading">
    <template v-slot:buttons>
      <v-btn
          v-if="images.length > 0"
          @click.native="validateSelectedCrops"
          :disabled="loading || selectedAnnotationIds.length === 0"
          color="primary">
        {{$t('myboxes.validate_selected') || 'Validate Selected'}}
      </v-btn>
    </template>
    <template v-slot:content>
      <!-- Top row: 4 validated annotations sorted by liked -->
      <row v-if="topValidatedAnnotations.length > 0" style="margin-bottom: 20px; background-color: #f5f5f5; padding: 15px; border-radius: 4px;">
        <col12>
          <div style="font-size: 1.25rem; color: #666; margin-bottom: 10px;">
            {{$t('myboxes.top_validated_annotations') || 'Top validated annotations'}}
          </div>
          <row>
            <col3
                v-for="image in topValidatedAnnotations" :key="image.bbox_id"
            >
              <grid-item :no_toggle="true"
                         :image="image"
                         :selected="false"
                         @remove_item="removeGridItem"
                         @select_item="() => {}" 
                         :validation="image.validation">
              </grid-item>
            </col3>
          </row>
        </col12>
      </row>
      <grid ref="grid" @reload="load" :items="remainingImages" :no_toggle="false" v-on:remove_item="removeGridItem" @update_selection_annotation_ids="updateSelectedAnnotations"></grid>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import Grid from "@/components/Grid";
import GridItem from "@/components/GridItem";
import Row from "@/components/layout/Row";
import Col12 from "@/components/layout/Col12";
import Col3 from "@/components/layout/Col3";

export default {
  name: "LabelCropsModal",
  components: {Grid, Modal, GridItem, Row, Col12, Col3},
  props: {
    label_name: {required: true},
    filters: {required: true},
    total_count: {required: true}
  },
  data () {
    return {
      loading: false,
      images: [],
      topValidatedAnnotations: [],
      selectedAnnotationIds: [],
      grid_selected_ids: [],
    }
  },
  computed: {
    remainingImages() {
      // Get bbox_ids of top validated annotations
      let topBboxIds = this.topValidatedAnnotations.map(img => img.bbox_id);
      // Return all images except the top 4 validated ones
      return this.images.filter(img => !topBboxIds.includes(img.bbox_id));
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async loadTopValidatedAnnotations() {
      // Create filters for validated annotations only
      let validatedFilters = [
        {"type": 17, "value": "Yes"} // annotation validated
      ];
      
      let results = await this.$api.annotation.filter_by_label(validatedFilters, this.label_name);
      let items = results.items;

      console.log('top validated annotations', items);

      // Sort by liked (liked first)
      items.sort((a, b) => {
        const aLiked = a.liked || false;
        const bLiked = b.liked || false;
        if (aLiked === bLiked) return 0;
        return aLiked ? -1 : 1;
      });

      // Limit to 4 items
      items = items.slice(0, 4);

      // Load crops for top validated annotations
      let topValidatedImages = [];
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let data = await this.$api.asset.get_crop(item.url, item.bbox, item.asset_id);
        let cropData = data.crops.map((crop) => {
          return {
            meta: item.meta,
            data: crop.crop,
            certainty: item.certainty,
            bbox_id: item.bbox_id,
            label: item.label,
            id: item.asset_id,
            annotation_type: item.annotation_type,
            validated: item.validated || false,
            liked: item.liked || false,
            validation: null
          }
        });
        topValidatedImages = topValidatedImages.concat(cropData);
      }
      
      this.$set(this, 'topValidatedAnnotations', topValidatedImages);
    },
    async load() {
      this.images = [];
      this.$set(this, 'topValidatedAnnotations', []);
      this.$set(this, 'selectedAnnotationIds', []);
      this.$set(this, 'grid_selected_ids', []);
      this.$set(this, 'loading', true)

      // Load top validated annotations separately
      await this.loadTopValidatedAnnotations();

      // Load regular annotations
      let results = await this.$api.annotation.filter_by_label(this.filters, this.label_name);
      
      let items = results.items

      // Limit to 40 items
      if (items.length > 40) {
        items = items.slice(0, 40);
      }

      if (items.length === 0) {
        this.$set(this, 'loading', false)
        return;
      }

      for (let i = 0; i < items.length; i++) {
        let item = items[i]

        let data = await this.$api.asset.get_crop(item.url, item.bbox, item.asset_id);
        let cropData = data.crops.map((crop) => {
          return {
            meta: item.meta,
            data: crop.crop,
            certainty: item.certainty,
            bbox_id: item.bbox_id,
            label: item.label,
            id: item.asset_id,
            annotation_type: item.annotation_type,
            validated: item.validated || false,
            liked: item.liked || false,
            validation: null
          }
        })
        this.images = this.images.concat(cropData);
      }
      
      this.$set(this, 'loading', false)
      // Select all items by default
      this.$nextTick(() => {
        if (this.$refs.grid && this.remainingImages.length > 0) {
          this.$refs.grid.toggleSelectAll(true);
        }
      });
    },
    updateSelectedAnnotations(annotationIds) {
      // Store grid selections
      this.$set(this, 'grid_selected_ids', annotationIds);
      // Use grid selections directly (top row doesn't have checkboxes)
      this.$set(this, 'selectedAnnotationIds', annotationIds);
    },
    async validateSelectedCrops() {
      if (this.selectedAnnotationIds.length === 0) {
        return;
      }
      this.$set(this, 'loading', true);
      await this.$api.box.mark_bboxes_validated(this.selectedAnnotationIds);
      await this.load();
      this.$set(this, 'loading', false);
    },
    removeGridItem(asset_id) {
      let filteredImages = this.images.filter((image) => {
        return image.id !== asset_id
      });
      this.$set(this, 'images', filteredImages);
    },
    close() {
      this.$emit('close_modal')
    },
  }
}
</script>

<style scoped>

</style>

